import "../modules/imageZoom";
import "../modules/listingShowPage";
import "../modules/productPage";
import "../modules/productQuantities";
import "../modules/shippingCalculatorDrawer";
import "../modules/productVariants";
import "../modules/sustainabilityDrawer";
import "../modules/productCarousel";
import "../modules/initialiseProductPageCarousel";

document.addEventListener("DOMContentLoaded", async () => {
  document.addEventListener("click", event => {
    const swatch = event.target.closest(".product-swatches .swatch");
    if (!swatch) return;

    const { href } = swatch.dataset;
    if (!href) return;

    window.location.assign(href);
  });

  const importPromises = [];

  if (document.querySelector(".js-b2b-radio-input")) {
    importPromises.push(
      import("../modules/b2BProducts").then(module => module.default())
    );
  }

  if (document.querySelector("#explainer-drawer-app")) {
    importPromises.push(
      import("../modules/explainerDrawer").then(module => module.default())
    );
  }

  if (document.querySelector(".slider-overlay")) {
    importPromises.push(
      import("../modules/imageSliderReveal").then(module => module.default())
    );
  }

  if (document.querySelector("#js-photobook-add-cta")) {
    importPromises.push(
      import("../modules/photobookPdpCta").then(module => module.default())
    );
  }

  if (document.querySelector("#js-photo-product-add-cta")) {
    importPromises.push(
      import("../modules/photoProductPdpCta").then(module => module.default())
    );
  }

  // Shared imports with productVariant.js
  const initializeProductVariantImports = (
    await import("../modules/productVariantImports")
  ).default;

  initializeProductVariantImports();

  await Promise.all(importPromises);
});
